<script setup lang="ts">
import { ref } from 'vue';

const animation = ref('full-spin');

// setTimeout(() => {
//   animation.value = 'half-spin';
// }, 8000);

// setTimeout(() => {
//   animation.value = 'spin';
// }, 3000);
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    style="margin: auto; display: block"
    width="100px"
    height="100px"
    viewBox="0 0 100 100"
    preserveAspectRatio="xMidYMid"
  >
    <g transform="translate(50,50)">
      <circle
        class="ring blue"
        cx="0"
        cy="0"
        r="43"
        stroke="#38A5DD"
        pathLength="100"
        :class="{
          [animation]: true,
        }"
      />
      <circle
        class="ring red"
        cx="0"
        cy="0"
        r="34"
        stroke="#D8166A"
        pathLength="100"
        :class="{
          [animation]: true,
        }"
      />
      <circle
        class="ring orange"
        cx="0"
        cy="0"
        r="25"
        stroke="#FF9E1B"
        pathLength="100"
        :class="{
          [animation]: true,
        }"
      />
      <circle
        class="ring green"
        cx="0"
        cy="0"
        r="16"
        stroke="#90A901"
        pathLength="100"
        :class="{
          [animation]: true,
        }"
      />
      <circle cx="-43" cy="0" r="4" fill="#38A5DD" />
      <circle cx="34" cy="0" r="4" fill="#D8166A" />
      <circle cx="-25" cy="0" r="4" fill="#FF9E1B" />
      <circle cx="16" cy="0" r="4" fill="#90A901" />
    </g>
  </svg>
</template>

<style scoped>
circle.ring {
  fill: transparent;
  stroke-width: 8;
  stroke-dasharray: 100;
  stroke-dashoffset: 100;
  stroke-linecap: round;
  transition: transform 1s;
}
circle.ring.full-spin {
  animation: full-spin 2s ease infinite;
  animation-fill-mode: forwards;
}
circle.ring.half-spin {
  animation: half-spin 1s ease 1;
  animation-fill-mode: forwards;
}
circle.ring.green {
  transform: translateY(0px);
  animation-delay: 300ms;
}
circle.ring.orange {
  transform: translateY(0px) rotate(180deg);
  animation-delay: 200ms;
}
circle.ring.red {
  transform: translateY(0px);
  animation-delay: 100ms;
}
circle.ring.blue {
  transform: translateY(0px) rotate(180deg);
  animation-delay: 0ms;
}

@keyframes full-spin {
  0% {
    stroke-dashoffset: 100;
  }
  10% {
    stroke-dashoffset: 100;
  }
  50% {
    stroke-dashoffset: 0;
  }
  90% {
    stroke-dashoffset: -100;
  }
  100% {
    stroke-dashoffset: -100;
  }
}

@keyframes half-spin {
  0% {
    stroke-dashoffset: 100;
  }
  20% {
    stroke-dashoffset: 100;
  }
  100% {
    stroke-dashoffset: 0;
  }
}
</style>
